// A routing service that hangs never fails on its own, so the caller could not report the route as unavailable.
const ROUTE_TIMEOUT_MS = 8_000;

export async function failIfRouteUnansweredAsync<T>(request: Promise<T>): Promise<T> {
    let timeoutId = 0;

    const unanswered = new Promise<never>((_, reject) => {
        timeoutId = window.setTimeout(
            () => reject(new Error("The routing service did not answer in time.")),
            ROUTE_TIMEOUT_MS
        );
    });

    try {
        return await Promise.race([request, unanswered]);
    }
    finally {
        window.clearTimeout(timeoutId);
    }
}
